import { Result } from '@cplug/frontend-core/utils'

/** Script em index.html/200.html (CDN pode não servir JSON novo na raiz). */
export const APP_BUILD_INFO_DOM_ID = 'cplug-erp-system-info'
export const APP_BUILD_INFO_PUBLIC_PATH = '/cplug-erp-system-info.json'

export interface AppBuildInfoApp {
  buildLabel: string
  displayName: string
  packageName: string
  packageVersion: string
  releaseTag?: string
}

export interface AppBuildInfoBuild {
  branch: string
  builtAt: string
  commitSha: string
  commitShaFull?: string
  commitUrl?: string
  environment: string
  jobName?: string
  pipelineId?: string
  pipelineUrl?: string
}

export interface AppBuildInfo {
  app: AppBuildInfoApp
  build: AppBuildInfoBuild
  dependencies: Record<string, string>
}

/** CI `build:main` define `ENVIRONMENT_NAME=production`. Demais ambientes exibem modal completo. */
export function parseAppBuildInfoRaw (raw: string): AppBuildInfo | undefined {
  const parseResult = Result.ofFunction((): unknown => JSON.parse(raw))
  if (parseResult.isError()) {
    return undefined
  }
  const json = parseResult.getValue()
  if (!isAppBuildInfo(json)) {
    return undefined
  }
  return json
}

export function isProductionBuildEnvironment (environment: string): boolean {
  return environment === 'production'
}

/** Versão exibida em produção: tag de release (sem `v`) ou `packageVersion`. */
export function resolveProductionDisplayVersion (app: AppBuildInfoApp): string {
  const tag = app.releaseTag?.trim()
  if (tag) {
    return tag.startsWith('v') ? tag.slice(1) : tag
  }
  return app.packageVersion
}

export function isAppBuildInfo (value: unknown): value is AppBuildInfo {
  if (typeof value !== 'object' || value === null) {
    return false
  }
  const record = value as Record<string, unknown>
  if (typeof record.app !== 'object' || record.app === null) {
    return false
  }
  if (typeof record.build !== 'object' || record.build === null) {
    return false
  }
  if (typeof record.dependencies !== 'object' || record.dependencies === null) {
    return false
  }
  const app = record.app as Record<string, unknown>
  return typeof app.displayName === 'string' &&
    typeof app.buildLabel === 'string' &&
    typeof app.packageVersion === 'string'
}
